<template>
  <JqxWindow ref="myWindow" :theme="'material'" :width="550" :height="450" :resizable="true" :isModal="true"
             :autoOpen="false" :initContent="init">
    <div class="col-md"><strong>Utente</strong>
    </div>
    <div>

      <JqxSplitter ref="splitter" :width="850" :heigth="300" :autoCreate="false" :panels="panels">
        <div class="splitter-panel" :theme="'material'">
          <JqxValidator ref="myValidator" :rules="rules"
                        :hintType="'label'" @validationSuccess="onValidationSuccess($event)">
            <div style="margin-top: 5px;margin-left: 5px;">
              <form id="form" style="overflow: hidden;" action="./">
                <div class="form-group">
                  <label>Nome</label>
                  <br><br>
                  <JqxInput class="name" :theme="'material'" ref="name"></JqxInput>
                </div>
                <div class="form-group">
                  <label>Email</label>
                  <br><br>
                  <JqxInput class="email" :theme="'material'" ref="email"></JqxInput>
                </div>

                <div class="form-group">
                  <label>Password</label>
                  <br><br>
                  <JqxPasswordInput :popupZIndex="10000" :theme="'material'" ref="password"
                                    class="password"></JqxPasswordInput>
                </div>
                <div class="form-group">
                  <label>Conferma password</label>
                  <br><br>
                  <JqxPasswordInput :popupZIndex="10000" :theme="'material'" ref="passwordConfirm"
                                    class="passwordConfirm"></JqxPasswordInput>
                </div>
              </form>
            </div>
          </JqxValidator>
        </div>
        <div class="splitter-panel" :theme="'material'">
          <div style="margin-top: 5px;margin-left: 5px;">
            <div class="form-group">
              <label>Tipologia utente</label>
              <br>
              <JqxComboBox :autoDropDownHeight="true" :selectedIndex="0" ref="role" :popupZIndex="10000"
                           :displayMember="'descrizione'" :valueMember="'descrizione'" :source="dataAdapterRolesUser"
                           :theme="'material'"></JqxComboBox>
            </div>
            <div class="form-group">
              <label>Impianto</label>
              <br>
              <JqxComboBox :autoDropDownHeight="true" :selectedIndex="0" ref="impianto" :popupZIndex="10000"
                           :displayMember="'ragione_sociale'" :valueMember="'id'"
                           :source="dataAdapterImpianto"
                           :theme="'material'"></JqxComboBox>
            </div>
          </div>
        </div>
      </JqxSplitter>

      <card>
        <div class="float-right">
          <JqxButton :theme="'material'" @click="buttonClicked()">
            Save
          </JqxButton>

          <JqxButton :theme="'material'" @click="cancelParent">
            Cancel
          </JqxButton>
        </div>
      </card>
    </div>
  </JqxWindow>
</template>

<script>

  import JqxWindow from "~jqx/jqwidgets-vue/vue_jqxwindow.vue";
  import JqxButton from "~jqx/jqwidgets-vue/vue_jqxbuttons.vue";
  import JqxInput from "~jqx/jqwidgets-vue/vue_jqxinput.vue";
  import JqxNumberInput from "~jqx/jqwidgets-vue/vue_jqxnumberinput.vue";
  import JqxComboBox from "~jqx/jqwidgets-vue/vue_jqxcombobox.vue";
  import JqxCheckBox from "~jqx/jqwidgets-vue/vue_jqxcheckbox.vue";
  import JqxSplitter from '~jqx/jqwidgets-vue/vue_jqxsplitter.vue';
  import JqxPasswordInput from '~jqx/jqwidgets-vue/vue_jqxpasswordinput.vue';
  import JqxValidator from '~jqx/jqwidgets-vue/vue_jqxvalidator.vue';


  export default {
    name: "UtentiDetails",
    components: {
      JqxInput,
      JqxNumberInput,
      JqxButton,
      JqxWindow,
      JqxComboBox,
      JqxCheckBox,
      JqxSplitter,
      JqxPasswordInput,
      JqxValidator

    },
    data: function () {
      return {
        panels: [{size: 300}, {size: 100}],
        dataAdapterRolesUser: new jqx.dataAdapter(this.sourceroleuser),
        dataAdapterImpianto: new jqx.dataAdapter(this.sourceimpianto),
        rules: [
          {input: ".name", message: "Il nome è necessario!", action: 'keyup, blur', rule: 'required'},
          {input: ".email", message: "La mail è necessaria!", action: 'keyup, blur', rule: 'required'},
          {input: ".password", message: "La password è necessaria!", action: 'keyup, blur', rule: 'required'},
          {input: ".passwordConfirm", message: "La password è necessaria!", action: 'keyup, blur', rule: 'required'},
          {
            input: ".passwordConfirm",
            message: "Non corrispondono, Sfasi?!",
            action: 'keyup, blur',
            rule: (input, commit) => {
              let firstPassword = this.$refs.password.val();
              let secondPassword = this.$refs.passwordConfirm.val();
              return firstPassword == secondPassword;
            }
          },
        ]
      }
    },
    beforeCreate: function () {
      this.sourceroleuser = {
        datatype: 'json',
        datafields: [
          {name: 'descrizione'},
        ],
        url: '/api/cruds/read?t=AnagraficaRolesUser'
      };
      this.sourceimpianto = {
        datatype: 'json',
        datafields: [
          {name: 'ragione_sociale'},
          {name: 'id'},
        ],
        url: '/api/cruds/read?t=AnagraficaImpianti&q=allforsourceinput'
      };
    },
    methods: {
      cancelParent() {
        this.$parent.cancelBtn();
      },
      init: function () {
        let tmp = {width: "98%", height: "80%", theme: "material"};
        this.$refs.splitter.createComponent(tmp);
      },
      buttonClicked: function () {
        this.$refs.myValidator.validate(document.getElementById('form'));
      },
      onValidationSuccess: function (event) {
        this.$parent.saveBtn();
      }
    }
  }
</script>

<style scoped>
  .jqx-splitter {
    border: none;
  }
</style>



// WEBPACK FOOTER //
// resources/js/components/cruddetails/UtentiDetails.vue